import React, {FC} from "react"

import {Deal} from "@irati/types"
import PropTypes from "prop-types"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import PerksBannerQueryComponent from "@irati/deals/apollo/query/PerksBanner"
import Slider from "@irati/ui/src/Slider"
import {HeroSliderSettings} from "@irati/ui/src/Hero"
import {RouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {H3} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"
import HeroPerk from "@irati-web/perks/src/components/HeroPerk"
import DealPages from "@irati-web/perks/src/enums/DealPages"
import tracking from "@irati-tracking/homepage/homepage"

interface Props extends InjectIntl {}

const AdsCarousel: FC<Props> = ({formatMessage}, {apps}) => {
  return (
    <PerksBannerQueryComponent>
      {({data: {homepageBanners}}) => {
        if (!homepageBanners.length) {
          return null
        }

        return (
          <Spacing paddingTop={5}>
            <Flex justifyContent="space-between" alignItems="center" marginBottom={3}>
              <H3>
                <FormattedMessage id="platform.homepage.lanes.deals.title" />
              </H3>
              <RouterLink to="/" cta app={apps.PERKS}>
                <Flex>
                  <FormattedMessage id="platform.homepage.seeMore" />
                  <Icon icon={IconTypes.arrowRight} marginLeft={1} />
                </Flex>
              </RouterLink>
            </Flex>
            <Slider slidesToShow={1} settings={HeroSliderSettings}>
              {homepageBanners?.map((deal: Deal, i: number) => (
                <HeroPerk
                  key={deal.uuid}
                  deal={deal}
                  onClick={() =>
                    tracking.clickPerk(deal, {
                      sectionHeader: formatMessage({id: "platform.homepage.lanes.deals.title"}),
                      position: i + 1,
                      source: DealPages.PLATFORM_HOMEPAGE.toLowerCase()
                    })
                  }
                />
              ))}
            </Slider>
          </Spacing>
        )
      }}
    </PerksBannerQueryComponent>
  )
}

AdsCarousel.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default injectIntl(AdsCarousel)
